export enum CapacitySetupType {
  OnlyCentro = 1,

  OnlyB8Ak = 2,

  Both = 3,
}
